module.exports = __webpack_public_path__ + "media/images/countrysquared/ee-5e13655670d1686feab1755b46d70632.svg";